import * as React from 'react';
const StarOnIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.80078 2.3999L10.1479 6.5458H14.5071L10.9804 9.10811L12.3275 13.254L8.80078 10.6917L5.27407 13.254L6.62115 9.10811L3.09444 6.5458H7.4537L8.80078 2.3999Z"
      fill="#3733FF"
    />
  </svg>
);
export default StarOnIcon;
